/*
 * This model helps to keep data between several modal windows.
 */
import FormUtils from "../../components/utils/form-utils.component";
import {ClassificationGroup} from "../classification-group";
import {Guide} from "../guide";
import {FormulaCost} from "../formula-cost";
import {TranslateService} from "@ngx-translate/core";
import {InfixFormula} from "./infix-formula";

export class CostView {

    public value: boolean;
    public formula: any;
    public formulaIndex: any;
    public formulaType: string = "formula";
    public propertiesLoaded: boolean = false;
    public formulaLoaded: boolean = true;
    public idAsSlugMode: boolean = false;
    public isNewChange: boolean = false;
    public isInfix: boolean = false;
    public formulaMeta: any;
    public guides: Guide[] = [];
    public groups: ClassificationGroup[] = [];
    public infixFormula: InfixFormula = null;
    public formFields: any[] = [];
    public formFieldsGroup: any[] = [];
    public systemFields: any[] = [];
    public properties: any[] = [];
    public readonly idDataPrefix = "data.";
    public readonly idRowPrefix = "row.";
    public readonly infixSeparator: string = ";;";
    public readonly emptyFormula: string = "( )";
    public readonly mathFunctions: Array<{ value: string, label: string, conditionOnly: boolean, nestedGroupOnly: boolean, elementOnly: boolean }> = [
        { value: "", label: "", conditionOnly: false, nestedGroupOnly: false, elementOnly: false},
        {
            value: "translate",
            label: "translate",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: true,
        },
        {
          value: "cat",
          label: "concatenate",
          conditionOnly: false,
          nestedGroupOnly: true,
          elementOnly: false,
        },
        { value: "in", label: "in", conditionOnly: true, nestedGroupOnly: false, elementOnly: false},
        { value: "maxValue", label: "maxValue", conditionOnly: false, nestedGroupOnly: true, elementOnly: false},
        { value: "round", label: "round", conditionOnly: false, nestedGroupOnly: false, elementOnly: false},
        { value: "ceil", label: "ceil", conditionOnly: false, nestedGroupOnly: false, elementOnly: false},
        { value: "floor", label: "floor", conditionOnly: false, nestedGroupOnly: false, elementOnly: false},
        {
            value: "rounduphundred",
            label: "roundup hundred",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: false,
        },
        {
            value: "roundupthousand",
            label: "roundup thousand",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: false,
        },
        {
            value: "rounduphundredthousand",
            label: "roundup hundred thousand",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: false,
        },
        {
            value: "dataGridColumnTotal",
            label: "data grid column total",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: false,
        },
        {
            value: "gridRowCounter",
            label: "grid row counter",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: false,
        },
        {
            value: "extractValueFromGrid",
            label: "extract value from grid",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "penaltyMonths",
            label: "penalty months",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "substractDays",
            label: "substract days",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "addDays",
            label: "add days",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "substractMonths",
            label: "substract months",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "addMonths",
            label: "add months",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "substractYears",
            label: "substract years",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "addYears",
            label: "add years",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "overrideYear",
            label: "override year",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "overrideDate",
            label: "override date",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "daysDiff",
            label: "days difference",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "weeksDiff",
            label: "weeks difference",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "monthsDiff",
            label: "months difference",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "yearsDiff",
            label: "years difference",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "businessDaysDiff",
            label: "business days",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "workingTimeDiff",
            label: "working time",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "workingHoursDiff",
            label: "working hours",
            conditionOnly: false,
            nestedGroupOnly: true,
            elementOnly: false,
        },
        {
            value: "defaultZero",
            label: "default zero",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: true,
        },
        {
            value: "yearFromDate",
            label: "year from date",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: true,
        },
        {
            value: "monthFromDate",
            label: "month from date",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: true,
        },
        {
            value: "dayFromDate",
            label: "day from date",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: true,
        },
        {
            value: "getKeyFromCatalog",
            label: "get key from catalog",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: true,
        },
        {
            value: "getValueFromCatalog",
            label: "get value from catalog",
            conditionOnly: false,
            nestedGroupOnly: false,
            elementOnly: true,
        },
        {value: "sqrt", label: "sqrt", conditionOnly: false, nestedGroupOnly: false, elementOnly: false},
    ];
    public readonly mathOperators: Array<{ value: string, label: string }> = [
        {value: "+", label: "+"},
        {value: "-", label: "-"},
        {value: "*", label: "*"},
        {value: "/", label: "/"},
        // {value: "%", label: "%"},
        // {value: "‰", label: "‰"},
        {value: "^", label: "^"},
        {value: "#", label: "#"},
        {value: ",", label: ","},
    ];
    public readonly conditionalOperators: Array<{ value: string, label: string }> = [
        {value: ">", label: ">"},
        {value: ">=", label: ">="},
        {value: "=", label: "="},
        {value: "!=", label: "≠"},
        {value: "<=", label: "<="},
        {value: "<", label: "<"},
    ];
    public readonly logicalOperators: Array<{ value: string, label: string }> = [
        {value: "||", label: "OR"},
        {value: "&&", label: "AND"},
    ];

    public getPropertyById(id: string) {
        const property = {
            label: "",
            name: "textValue",
            value: null,
            type: "token",
        };
        console.log("id", id);

        id = id.slice(1, -1); // remove quotations
        if (!id.startsWith(this.idDataPrefix) && !id.startsWith(this.idRowPrefix)) {
            // @ts-ignore
          property.value = id;
          return property;
        } else if (id.startsWith(this.idDataPrefix)) {
            id = id.slice(5); // remove "data." prefix
        } else {
            id = id.slice(4); // remove "row." prefix
        }
        const propertyMatch = this.properties.some((prop) => {
            if (this.idAsSlugMode || prop.compareById) {
                if (prop.id === id) {
                    property.label = prop.label;
                    property.name = prop.id;
                    property.value = prop.id;
                    return true;
                }
            } else {
                const slug = FormUtils.generateGuideIdFromTitle(prop.label);
                if (slug === id) {
                    property.label = prop.label;
                    property.name = prop.id;
                    property.value = slug;
                    return true;
                }
            }
        });
        if (!propertyMatch) {
            this.systemFields.some((field) => {
                if (field.key === id) {
                    property.label = field.name;
                    property.name = field.key;
                    property.value = field.key;
                    return true;
                }
            });
        }
        return property;
    }

    public addIdWrapper(id: any, type, isPretty) {
        if (!isNaN(Number(id))) {
            return id;
        } else if (id.match(/^'\d{4}-\d{2}-\d{2}'$/g)) {
            return id;
        } else if (id.match(/^\d{4}-\d{2}-\d{2}/g)) {
            return `'${id}'`;
        } else if (id.match(/^'data\.[a-zA-Z0-9]*'$/g)) {
            return id;
        } else if (id.match(/^'row\.[a-zA-Z0-9]*'$/g)) {
            return id;
        } else if (type === "textValue") {
          return `'${id}'`;
        } else if (type === "dateToday") {
          return `${id}`;
        }
        return `'${this.idDataPrefix}${id}'`;
    }

    public reloadPrettyPrint(cost: FormulaCost, translateService: TranslateService) {
        if (!this.infixFormula) { this.infixFormula = new InfixFormula(this.emptyFormula, this, translateService); }
        cost.formulaCostItems.forEach((item) => {
            if (item.infixFormula) {
                this.infixFormula.value = item.infixFormula;
                this.infixFormula.initProperties();
                item.prettyPrintInfixFormula = this.infixFormula.prettyPrint();
            }
        });
    }
}
